import { Component, Input, OnInit } from '@angular/core';
import type { TTextTheme } from './types';


@Component({
    selector: 'text',
    templateUrl: 'text.component.html',
    styleUrls: ['./text.component.scss'],
    standalone: false
})

export class TextComponent implements OnInit {
    @Input() public theme: TTextTheme = 'paragraph';
    @Input() public required = false;

    public constructor() { }

    public ngOnInit() { }
}
